import {Row, Col } from 'antd';

import '../style/style.css';

import MandantenTableContainer from '../../MandantenTableThingy/container/table_container';
import MandantenInputContainer from '../../MandantenInputThingy/container/Container';

export interface WatchdogViewProps{
    name:string[];
    refreshInterval:string;
}

export function WatchdogView(){
    return (
        <div  className="site-card-wrapper">
            <Row gutter={16}>
            <Col span={0.5}></Col>
            <Col span={23}>
              
        <Row>
            <Col span={20}>
                <MandantenTableContainer id={"MandantenTable"} />
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={16}>
                <MandantenInputContainer id={"MandantenInput"} url={"undefined"}/> 
            </Col>
            
        </Row>

        </Col>
        <Col span={0.5}></Col>
        </Row>
        <Row gutter={16}>
        <Col span={0.5}></Col>
            <Col span={16}>
            
        
        </Col>
        </Row>
      </div>
    )
}

